/**
 * Payment method constants used across the application
 */
export enum PaymentMethod {
  PAYPAL = 'paypal',
  IBAN = 'iban',
  NONE = 'none'
}

/**
 * Cart status constants used across the application
 */
export enum CartStatus {
  ACTIVE = 'active',
  CONVERTED = 'converted',
  ABANDONED = 'abandoned'
}

/**
 * Order status constants used across the application
 */
export enum OrderStatus {
  PAYMENT_PENDING = 'payment_pending',
  PAYMENT_COMPLETE = 'payment_complete',
  CANCELED = 'canceled'
}

/**
 * Payment method type for TypeScript type checking
 */
export type PaymentMethodType = PaymentMethod.PAYPAL | PaymentMethod.IBAN | PaymentMethod.NONE | '';

/**
 * Order status type for TypeScript type checking
 */
export type OrderStatusType = OrderStatus.PAYMENT_PENDING | OrderStatus.PAYMENT_COMPLETE | '';
